"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ArrowIndicatorIcon = function (_a) {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", __assign({ width: "14", height: "7", viewBox: "0 0 14 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M7.0001 7.00097C6.76609 7.00146 6.53943 6.91929 6.3601 6.76897L0.360099 1.76897C0.15628 1.59923 0.0282375 1.35547 0.00413903 1.09133C-0.0199594 0.827183 0.0618604 0.564284 0.231599 0.360465C0.401338 0.156646 0.645091 0.0286037 0.909236 0.00450524C1.17338 -0.0195932 1.43628 0.0622266 1.6401 0.231965L7.0111 4.70796L12.3731 0.392965C12.5799 0.228397 12.8434 0.152367 13.106 0.18149C13.3687 0.210614 13.6091 0.342522 13.7748 0.54839C13.9405 0.754258 14.018 1.01734 13.9903 1.28016C13.9626 1.54297 13.8321 1.78414 13.6271 1.95097L7.6271 6.77896C7.44955 6.92234 7.22831 7.00068 7.0001 7.00097Z", fill: "#6C6C6C" })));
};
exports.default = ArrowIndicatorIcon;
